import { ElementRef, Injectable } from '@angular/core';
import { AppState } from '../app.service';
import { Router } from '@angular/router';
import * as _ from 'underscore';
import { ToasterService } from '../toaster.service';
import { SpinnerService } from '../spinner.service';
import { RoutineV2Service } from '../routine-v2/routine-v2.service';
import { DailyStepsService } from '../daily-steps/daily-steps.service';
import { AlertGiveFeedbackCommitmentComponent } from '../alert-give-feedback-commitment/alert-give-feedback-commitment.component';
import { MatDialog } from '@angular/material/dialog';
import { HomeV5Service } from '../pages/home-v5/home-v5.service';
import { AlertController, AnimationController, ModalController } from '@ionic/angular';
import { ClientService } from '../client/client.service';
import { JournalService } from '../pages/journal/journal.service';
import { LibraryService } from '../my-library/library.service';
import { AnimationsService } from '../shared/animations.service';
import { I18n } from '../i18n.service';
import { FullScreenAudioComponent } from '../full-screen-audio/full-screen-audio.component';
import { FullScreenVideoComponent } from '../full-screen-video/full-screen-video.component';
import { FullScreenDocumentComponent } from '../my-library/full-screen-document.component';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import mixpanel from 'mixpanel-browser';
import { AlertConfirmNotificationComponent } from '../alert-confirm-notification/alert-confirm-notification.component';
import { AlertReviewRoutineComponent } from '../alert-review-routine/alert-review-routine.component';
import { AlertNotificationUpdateComponent } from '../alert-notification-update/alert-notification-update.component';
import * as moment from 'moment';
import { AlertAnimationComponent } from '../alert-animation/alert-animation.component';
import { WeekendCalendarComponent } from '../routine-v2/weekend-calendar.component';
import { map, catchError } from 'rxjs/operators';
import { AlertUnlockLevelComponent } from '../alert-unlock-level/alert-unlock-level.component';
import { KyperChapters, Path } from '../path/path-v2.model';
import { CohortService } from '../cohorts/cohort.service';
import { SurveyService } from '../survey/survey.service';
import { AnalyticsServiceService } from '../services/analytics-service.service';
import { Client } from '../client/client.model';
import { MyCommitmentsComponent } from '../my-commitments/my-commitments.component';
import * as confetti from 'canvas-confetti';
import { ReoptHabitLevelModalComponent } from '../reopt-habit-level-modal/reopt-habit-level-modal.component';
import { MyCommitmentsService } from '../my-commitments/my-commitments.service';
import { CordovaService } from '../cordova.service';
import { timeZones } from '../time-zones.data';
import { Habit } from '../habit/habit.model';
import { Document } from '../document/document.model';
import { Survey } from '../survey/survey.model';
import { InoutScreen } from '../inout-screen/inout-screen.model';
import { ContentSurvey } from '../content-survey/content-survey.model';
import { Question } from '../question/question.model';
import { Reflection } from '../my-library/full-screen-reflection/reflection.model';
import { RoutineInfo } from '../routine-v2/routine-info.model';
import { Poll } from '../poll/poll.model';
import { OnboardingSteps } from '../path/onboarding-steps.model';
import { TodoListModel } from '../to-do-list/todo-list.model';
import { DailyStepsContentWebModalV2Component } from './daily-steps-content-web-modal-v2/daily-steps-content-web-modal-v2.component';
import { DailySteps } from '../path/path-daily-steps-v2.model';
import { KyperDataApiService } from '../services/kyper-data-api.service';

@Injectable({
  providedIn: 'root'
})
export class HomeUiService {

  videoFormats = ['.mp4', '.mov', '.avi', '.avchd', '.f4v', '.mkv', '.wmv','youtube.com', 'webm', 'html5', 'HTML5', 'watch'];
  audioFormats = [".mp3"];
  makeHabit: boolean
  isonboardingcompleted: any;
  path:Path;
  isMobile:boolean;
  clientId;
  modalStack =[];
  selectedTimings =[];
  isDarkTheme: boolean;
  API_URL: string = environment.apiBaseUrl
  UPDATE_DATES = '/users/update_logged_in_dates'
  GET_DAILY_STEPS_STATUS = '/get_daily_steps'
  GET_KYPER_CHAPTER_STEPS_STATUS ='/get_step_details'
  GET_STEP_ACTION_POINTS_DATA = '/get_step_points'
  get_keyper_earned_action_points= '/get_earned_action_points'
  GET_DAILY_STREAKS_INFO= '/users/streaks'
  GET_CHAPTERS_INFO ='/update_user_chapters'
  counterId;
  currentUser;
  canvas: ElementRef;
  currentClient: Client;
  routineList;
  private apiStepDataSubject = new BehaviorSubject<any>(null);
  private fontSizeSubject = new BehaviorSubject<{heading: number; body: number}>({
    heading: parseFloat(localStorage.getItem('headingFontSize') || '20.84'),
    body: parseFloat(localStorage.getItem('bodyFontSize') || '14.44'),
  });
  get fontSize$() {
    return this.fontSizeSubject.asObservable();
  }
  updateFontSize(heading: number, body: number) {
    const clampedBody = Math.max(12, body);
    localStorage.setItem('headingFontSize', String(heading));
    localStorage.setItem('bodyFontSize', String(clampedBody));
    this.applyFontSizeCssVars(heading, clampedBody);
    this.fontSizeSubject.next({ heading, body: clampedBody });
  }
  private applyFontSizeCssVars(heading: number, body: number) {
    document.documentElement.style.setProperty('--app-body-font-size', `${body}px`);
    document.documentElement.style.setProperty('--app-heading-font-size', `${heading}px`);
  }
  localRoutineData;
  commitType;
  makeCommitment;
  activityCueTime;
  subRoutineAnswer;
  typeValue;
  hasNativeCalendar: any;
  dayTimeArray;
  get refreshStepApiData() {
    return this.apiStepDataSubject.asObservable();
  }
  constructor(private appState: AppState, 
    private route: Router,
    private toasterService: ToasterService,
    private routineService: RoutineV2Service,
    private dailyStepService: DailyStepsService,
    private clientService: ClientService,
    private dialog: MatDialog,
    private modalController: ModalController,
    private homev5Service: HomeV5Service,
    private alertController: AlertController,
    private i18n: I18n,
    private animationService: AnimationsService,
    private cohortService: CohortService,
    private animationCtrl: AnimationController,
    private analyticsService: AnalyticsServiceService,
    private surveyService: SurveyService,
    private commitService: MyCommitmentsService,
    private kyperApiService: KyperDataApiService,
    private httpclient: HttpClient) { 
    this.isMobile = this.appState.get('isMobile');
      const savedFontSize = this.fontSizeSubject.getValue();
      this.applyFontSizeCssVars(savedFontSize.heading, savedFontSize.body);
      const clientId = localStorage.getItem('clientId')
      // this.isDarkTheme = localStorage.getItem('theme') === 'dark';
      const savedTheme = localStorage.getItem('theme');

      if (!savedTheme) {
        this.isDarkTheme = true;
        localStorage.setItem('theme', 'dark');
      } else {
        this.isDarkTheme = savedTheme === 'dark';
      }

      if (clientId) {
        this.clientId = clientId
      }
      this.currentUser = this.appState.get('currentUser')
      this.path = this.appState.get('currentPath')
      this.counterId = this.appState.get("counterId");
      if (this.counterId) {
        console.log("counterIdConstructor", this.counterId);
      } else {
       this.appState.set("counterId", 0);
      }
    }
    toggleTheme() {
      console.log('inside toggle')
      this.isDarkTheme = !this.isDarkTheme;
      localStorage.setItem('theme', this.isDarkTheme ? 'dark' : 'light');
      mixpanel.track("Theme Changed", {'Theme': this.isDarkTheme ? 'Light' : 'Dark'})
    }
  
    isDark() {
      // console.log('isdark', this.isDarkTheme )
      return this.isDarkTheme;
    }
  openDocument(postTool, dialog, journalPathName) {
    let path = this.appState.get('currentPath')
    console.log('post :', postTool);
     let posts = this.appState.get("casualDocuments")
    let doc =this.appState.get('singleDocument');
    let post;
    posts?.forEach((doc)=>{
      if(doc.id ==postTool?.tool?.id){
        post =doc;
      }
    })
    if(post?.id == doc?.id) {
      post =this.appState.get('singleDocument')
    }
    this.appState.set('singleDocument', post)
    this.appState.set('journalPost', undefined)
    if (post.isRecommended && post.isRecommended === true) {
      this.appState.set('isCasualDocument', true)
    }
    dialog.closeAll();
    this.appState.set('journalPathName', journalPathName)
    let stepNumber = path.findChapterStepByScreenContentId(this.appState.get('DailyStepsData'), post.screenId,true)?.stepPosition;
    this.appState.set('journalStepNumber', stepNumber)
    const url = post.link;
    if (this.audioFormats.some(el => url.includes(el))) {
      console.log('Audio File',this.appState.get('isMobile'));
      if (this.appState.get('isMobile')) {
        this.openNextComponent(FullScreenAudioComponent, {data:post})
      } else {
        this.openNextComponent(FullScreenAudioComponent, {data:post},'desktop-library-custom')        
      }
    } else if (this.videoFormats.some(el => url.includes(el))) {
      console.log('Video File',this.appState.get('isMobile'));
      if (this.appState.get('isMobile')) {
        this.openNextComponent(FullScreenVideoComponent, {data:post})
      } else {
        this.openNextComponent(FullScreenVideoComponent, {data:post},'desktop-library-custom')
      }

    } else {
      console.log('Document',this.appState.get('isMobile'));
      if (this.appState.get('isMobile')) {
        this.openNextComponent(FullScreenDocumentComponent)
      } else {
        this.openNextComponent(FullScreenDocumentComponent,'','desktop-library-custom')        
      }

    }
  }
  

setModalStack(modal){
  this.modalStack.push(modal);
}
  // allpaths(clientId, type?) {
  //   this.clientService.getallpath(Number(clientId),type)
  //     .subscribe(client => {
  //       this.appState.set('allPathCount', client._data['paths']?.length);
  //       this.appState.set("allPathsData", client._data['paths']);
  //     })
  // }
  allpaths(clientId) {
    this.clientService.getAllpaths(Number(clientId))
      .subscribe((client:any) => {
        this.appState.set('allPathCount', client._data['paths']?.length);
        this.appState.set("allPathsData", client._data['paths']);
        // The client's Series catalogue, from the raw response: the typed Client model copies only
        // the fields it lists and `series` is not one of them. Stored here as well as in
        // all-paths-v2 because this is the call that runs at login, before that screen exists.
        this.appState.set('clientSeries', client._data['series'] || []);
      }, (error) => {
        // 401 (token gone) and 404 (no such client) both land here. Left unhandled, the request
        // failed silently and every screen that reads allPathsData saw an empty cycle list with no
        // way to tell "none" from "could not ask".
        console.log('allpaths failed', error);
      })
  }

  /**
   * Awaitable version of allpaths(): returns the cached client paths if already loaded,
   * otherwise fetches them once (allpaths is fired fire-and-forget at login, so the data
   * may not be ready yet when the cycle-select modal needs full path objects).
   */
  ensureAllPathsData(clientId: any): Promise<any[]> {
    const cached = this.appState.get('allPathsData');
    if (cached && cached.length) { return Promise.resolve(cached); }
    return new Promise((resolve) => {
      this.clientService.getAllpaths(Number(clientId)).subscribe(
        (client: any) => {
          const paths = client?._data?.['paths'] || [];
          this.appState.set('allPathCount', paths.length);
          this.appState.set('allPathsData', paths);
          resolve(paths);
        },
        () => resolve(this.appState.get('allPathsData') || [])
      );
    });
  }
  async getCohorts(clientId) {
    const client = this.appState.get('currentClient');
    // Cohorts are only meaningful when the client cohort toggle is ON. `isCohort` is nullable and
    // NULL means "never set", which the server reads as on — so only an explicit false is off.
    if (client?.isCohort === false) {
      this.appState.set('cohortsData', []);
      this.fetchCohortPaths([]);
      return;
    }
    // Reuse cohorts already resolved during login (or an earlier fetch this session) so we
    // don't hit the cohorts API twice on the first login instance.
    const cached = this.appState.get('cohortsData');
    if (cached?.length) {
      this.fetchCohortPaths(cached);
      return;
    }
    if (clientId) {
      await this.cohortService.getCohort(Number(clientId)).subscribe(cohort => {
        console.log("ccohorts data from query", cohort.data);
        this.fetchCohortPaths(cohort.data)
        this.appState.set("cohortsData",cohort.data)
      })
    } else {
      console.log('no cohort found')
    } 
  }
 
   fetchCohortPaths(cohorts)
  {
    let user = this.appState.get("currentUser");
      let cohortPathIds = []
    cohorts?.forEach(element => {
      if (element.id == user.cohortId) {
        cohortPathIds = element?.paths ? element.paths.map((path: any) => path.id) : []
      }
    });
    if(user.adhocPaths.length > 0){

      cohortPathIds.push(...user.adhocPaths)
    }
    // A path can be assigned via the cohort AND listed in adhocPaths; dedupe by id so it isn't double-counted.
    const uniquePathIds = new Set(cohortPathIds);
    // The active path may fall outside the cohort/adhoc set (e.g. a legacy assignment) but is
    // always reachable, so make sure it's counted too - otherwise "switch path" can end up hidden
    // even though the user genuinely has more than one path available to them. Adjusted on the
    // resulting id set, not cohortPathIds itself, which stays a pure cohort/adhoc list.
    if (user.activePathId) {
      uniquePathIds.add(user.activePathId);
    }
    this.appState.set('cohortPathsCount', uniquePathIds.size);
  }

  /**
   * A user's accessible "cycles" (a cycle == a Path id), as the server resolves them.
   * `user.entitledPathIds` already covers every route — direct, cohort, Series, Series via
   * cohort — honours the client's cohort toggle, and is deduplicated, so nothing is rebuilt here.
   * The active path (activePathId) is always an accessible cycle when present.
   * This is the single source of truth for the "All cycles" tab (total > 1), the
   * login no-cycle gate, and the cycle list filtering.
   *
   * `client`, `cohorts` and `paths` are no longer consulted; they stay in the signature so callers
   * are unchanged.
   */
  computeCycleAccess(user: any, client?: any, cohorts?: any[], paths?: any[]): {
    assignedIds: number[]; availableIds: number[]; totalCount: number;
    hasActivePath: boolean; hasAnyCycle: boolean;
  } {
    const assigned = new Set<number>(
      this.toIdList(user?.entitledPathIds)
        .map(Number)
        .filter((id: number) => !Number.isNaN(id))
    );
    const activePathId = user?.activePathId ? Number(user.activePathId) : null;
    const available = new Set<number>(assigned);
    if (activePathId != null) { available.add(activePathId); }
    return {
      assignedIds: [...assigned],
      availableIds: [...available],
      totalCount: available.size,
      hasActivePath: activePathId != null,
      hasAnyCycle: available.size > 0,
    };
  }

  /**
   * Id lists can arrive as a real array, a JSON string ("[5,7]"), a comma-separated string
   * ("5,7"), or a single number — the User model even types `adhocPaths` as `number`. Normalize to
   * an array so a non-array shape doesn't silently drop ids.
   */
  private toIdList(raw: any): any[] {
    if (Array.isArray(raw)) { return raw; }
    if (typeof raw === 'number') { return [raw]; }
    if (typeof raw === 'string' && raw.trim()) {
      try {
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : (parsed != null ? [parsed] : []);
      } catch {
        return raw.split(',').map((s) => s.trim()).filter((s) => s.length > 0);
      }
    }
    return [];
  }

  /** Cycle access computed from current appState (currentUser's server-provided entitledPathIds). */
  getCycleAccess() {
    return this.computeCycleAccess(
      this.appState.get('currentUser'),
      this.appState.get('currentClient'),
      this.appState.get('cohortsData') || [],
      this.appState.get('allPathsData') || [],
    );
  }

  /** The "All cycles" tab/link is shown only when the user has more than one accessible cycle. */
  shouldShowAllCyclesTab(): boolean {
    return this.getCycleAccess().totalCount > 1;
  }

  /**
   * Login-time cycle resolution. When the cohort toggle is ON the cohorts must be
   * fetched so cohort cycles can be counted; when OFF only adhoc + active matter, so
   * no network call is needed. Caches cohortsData/cohortPathsCount as a side effect.
   */
  resolveCycleAccessForLogin(user: any, client: any): Observable<{
    assignedIds: number[]; availableIds: number[]; totalCount: number;
    hasActivePath: boolean; hasAnyCycle: boolean;
  }> {
    if (client?.isCohort !== false && client?.id) {
      return this.cohortService.getCohort(Number(client.id)).pipe(
        map((res: any) => {
          const cohorts = res?.data || [];
          this.appState.set('cohortsData', cohorts);
          this.fetchCohortPaths(cohorts);
          return this.computeCycleAccess(user, client, cohorts, this.appState.get('allPathsData') || []);
        }),
        catchError(() => {
          // Cohort fetch failed — degrade gracefully to the user's adhoc + active cycles instead of
          // erroring the login stream (which would leave the caller with no access result). Cache an
          // empty cohort set so downstream reads stay consistent with the access we return.
          this.appState.set('cohortsData', []);
          this.fetchCohortPaths([]);
          return of(this.computeCycleAccess(user, client, [], this.appState.get('allPathsData') || []));
        })
      );
    }
    return of(this.computeCycleAccess(user, client, [], this.appState.get('allPathsData') || []));
  }
  getRoutinesByCurrentDay(todoRoutines){
    let levels = []
    let todoLevelsList;
    if (todoRoutines) {
      todoRoutines?.forEach(element => {
        element.habits?.forEach(element => {
          if (element.commitmentStatement || element.isHabitUnlocked) {
            levels.push(element)
          }
        });
      });

      levels.forEach(element => {
        if(element.isHabitCompleted === false){
          todoLevelsList = element
        }
      });
      // todoLevelsList = levels
    }
    return todoLevelsList
  }
  getUnFinishedLevelBeforeRecommit(todoRoutine) {
    let todoLevelsList;
    if (todoRoutine) {
        todoRoutine?.habits?.forEach(element => {
        if(element?.isHabitUnlocked === true && element.isHabitCompleted === false && !todoLevelsList){
          todoLevelsList = element
        }
      });
    }
    return todoLevelsList
  }
  getRoutineLockedLevel(todoRoutine){
    let levels = []
    let todoLevelsList;
    if (todoRoutine) {
        todoRoutine?.habits?.forEach(element => {
          if (todoRoutine?.selectedHabitIds?.includes(element?.id) || todoRoutine?.selectedHabitIds?.length==0) {
            levels.push(element)
          }
        });
      levels?.forEach(element => {
        if((element?.isHabitUnlocked === false || element?.isUnlocked ==false) && !todoLevelsList){
          todoLevelsList = element
        }
      });
      // todoLevelsList = levels
    }
    return todoLevelsList
  }

    getRoutineUnselectedLevel(todoRoutine){
    let levels = []
    let todoLevelsList;
    if (todoRoutine) {
        todoRoutine?.habits?.forEach(element => {
            levels.push(element)
        });
      levels?.forEach(element => {
        if((element?.isHabitUnlocked === false || element?.isUnlocked ==false) && !todoLevelsList){
          todoLevelsList = element
        }
      });
      // todoLevelsList = levels
    }
    return todoLevelsList
  }

  getRoutineLockedLevelsList(todoRoutine){
    let levels = []
    let todoLevelsList=[];
    if (todoRoutine?.isHabitOpted) {
      todoRoutine?.habits?.forEach(element => {
        if (todoRoutine?.selectedHabitIds?.includes(element?.id) || todoRoutine?.selectedHabitIds?.length==0) {
          levels.push(element)
        }
        });
      levels?.forEach(element => {
        if((element?.isHabitUnlocked === false || element?.isUnlocked ==false) ){
          todoLevelsList.push(element)
        }
      });
      // todoLevelsList = levels
    }
    return todoLevelsList
  }
  getRoutineLevel(todoRoutine){
    let levels = []
    let todoLevelsList=[];
    if (todoRoutine) {
        todoRoutine?.habits?.forEach(element => {
          if (element.commitmentStatement) {
            levels.push(element)
          }
        });
      levels?.forEach(element => {
        if(element.isHabitCompleted === false && element?.isHabitUnlocked ===true ){
          todoLevelsList.push(element);
        }
      });
      // todoLevelsList = levels
    }
    return todoLevelsList
  }

  getCompletedRoutines(todoRoutine){
    let levels = []
    let todoLevelsList;
    if (todoRoutine) {
        todoRoutine?.habits?.forEach(element => {
          if (element.commitmentStatement) {
            levels.push(element)
          }
        });
      levels?.forEach(element => {
        if(!todoLevelsList){
          todoLevelsList = element
        }
      });
    }
    return todoLevelsList
  }

  getCompletedLevels(todoRoutine){
    let levels = []
    let todoLevelsList=[];
    if (todoRoutine) {
        todoRoutine?.habits?.forEach(element => {
          if (element.commitmentStatement) {
            levels.push(element)
          }
        });
      
      levels?.forEach(element => {
        if (element?.isHabitCompleted===true ){
          todoLevelsList.push(element);
        }
      });
    }
    return todoLevelsList
  }
  getTaskDurations(inoutScreens, currentDay) {
    let durationOfTask;
    if (inoutScreens!==null && !_.isUndefined(inoutScreens[currentDay - 1])) {

      if (inoutScreens[currentDay - 1].stime && inoutScreens[currentDay - 1].etime) {
        durationOfTask = inoutScreens[currentDay - 1].stime + " - " + this.appState.get('DailyStepsData')[currentDay - 1]?.inoutScreens?.etime;
        return durationOfTask;
      } else if (!inoutScreens[currentDay - 1].stime && inoutScreens[currentDay - 1].etime) {
        durationOfTask = inoutScreens[currentDay - 1].etime;
        return durationOfTask;
      } else {
        return "5 - 10";
      }
    } else {
      return "5 - 10";
    }
  }

  getSingleDoc(post) {
    this.path = this.appState.get('currentPath')
    this.appState.set('singleDocument', post.documents[0])
    this.appState.set('journalPathName', this.path.name)
    this.appState.set('journalStepNumber', post.startDay)
    this.appState.set('journalPost', post)
    this.appState.set('singleDocNote', post.text)
    let postData =post?.documents[0];
    postData.pathName=postData?.pathName? postData?.pathName: post.pathName
    postData.text =postData?.text? postData?.text: post.text
    if (postData.length >= 1) {
      const url = postData.link;
      if (this.audioFormats.some(el => url.includes(el))) {
        console.log('Audio File');
        mixpanel.track('Library-saved post', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Audio File','post id': post.id})
        if (this.appState.get('isMobile')) {
          this.openNextComponent(FullScreenAudioComponent, { data: postData })
        } else {
          this.openNextComponent(FullScreenAudioComponent, { data: postData },'desktop-library-custom')
        }
      } else if (this.videoFormats.some(el => url.includes(el))) {
        console.log('Video File');
        mixpanel.track('Library-saved post', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Video File','post id': post.id})
        if (this.appState.get('isMobile')) {
          this.openNextComponent(FullScreenVideoComponent, { data: postData })
        } else {
          this.openNextComponent(FullScreenVideoComponent, { data: postData },'desktop-library-custom')
        }
      } else {
        console.log('Document');
        mixpanel.track('Library-saved post', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Document File','post id': post.id})
        if (this.appState.get('isMobile')) {
          this.openNextComponent(FullScreenDocumentComponent)
        } else {
          this.openNextComponent(FullScreenDocumentComponent,'','desktop-library-custom')
        }
      }
    } else {
      mixpanel.track('Library-saved post', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Document File','post id': post.id})
      if (this.appState.get('isMobile')) {
        this.openNextComponent(FullScreenDocumentComponent)
      } else {
        this.openNextComponent(FullScreenDocumentComponent,'','desktop-library-custom')        
      }
    }
  }

  getCasualDoc(post) {
    this.path = this.appState.get('currentPath')
    this.appState.set('journalPost', undefined)
    this.appState.set('singleDocument', post)
    if (post.isRecommended && post.isRecommended === true) {
      this.appState.set('isCasualDocument', true)
      mixpanel.track('Library-tools post', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Casual Document', 'post id': post.id})
    }
    this.appState.set('journalPathName', this.path.name)
    this.appState.set('journalStepNumber', post.startDay)
    const url = post.link;
    if (this.audioFormats.some(el => url.includes(el))) {
      console.log('Audio File',post);
      mixpanel.track('Library-tools post', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Audio File','post id': post.id})
      if (this.appState.get('isMobile')) {
        this.openNextComponent(FullScreenAudioComponent, {data:post})        
      } else {
        this.openNextComponent(FullScreenAudioComponent, {data:post},'desktop-library-custom')
      }
    } else if (this.videoFormats.some(el => url.includes(el))) {
      console.log('Video File',post);
      mixpanel.track('Library-tools post', {'post title':post.title,'post imageurl':post.imageUrl, 'link': post.link, 'path name': post.path_name, 'post type':'Video File','post id': post.id})
      if (this.appState.get('isMobile')) {
        this.openNextComponent(FullScreenVideoComponent, {data:post})
      } else {
        this.openNextComponent(FullScreenVideoComponent, {data:post},'desktop-library-custom')
      }
    } else {
      console.log('Document');
      if (this.appState.get('isMobile')) {
        this.openNextComponent(FullScreenDocumentComponent)
      } else {
        this.openNextComponent(FullScreenDocumentComponent,'','desktop-library-custom')        
      }
    }

  }
  getRoutineByLevel(subItem, todoRoutines){
    let currentRoutine
    if (todoRoutines) {
      todoRoutines.forEach(element => {
        if (subItem.habitGroupId === element.habitGroupId) {
          currentRoutine = element
        }
      });
      return currentRoutine
    }
  }

  getReps(item) {
    return item.repsData
  }

  logaRep(routine: any, level: any, index: any, currentUser: any, currentDay: number, currentPath: any, modal: any=null) {
    let repsCommitArray = routine.habits.filter(item => item.repsData)
    let repsArray = repsCommitArray.map(this.getReps)
    this.isMobile = this.appState.get('isMobile');
    let totalRepsArray = Array.prototype.concat.apply([], repsArray);
    let totalLevelRepsArray = level.repsData.filter(item => item.is_completed === false)

    if (level.isHabitUnlocked === false) {
      this.toasterService.warning(this.i18n.t('Please complete previous level.'))
    } else {
      const requestData = {
        // 'user_id': currentUser.id,
        // 'path_id': routine.path_id,
        // 'routine_info_id': routine.routine_info_id,
        // 'level_id': level.id,
        // 'schedule_day': currentDay,
        // 'feedback': localStorage.getItem('repLogText'),
        // 'step': index + 1
        habit_group_id: level.habitGroupId,
        habit_id: level.id,
        rep_feedback: localStorage.getItem('repLogText'),
        rep: level.repsData?.findIndex(item => item.is_completed === false)+1
      }

      this.routineService.replog(requestData).subscribe(
        (response) => {
          let object = null
          // add reply to the local path routine_info
          // if (response && response.data && response.data.routine_info_id) {
          //   object = this.fetchScreenTypeContent('routineInfo')?.find(q => q.id === response.data.routine_info_id)
          // }

          this.toasterService.success(this.i18n.t('Rep Logged!'))
          this.kyperApiService.getHabits(routine.pathId)
          this.appState.set('isTodoReps', undefined)
          if (totalLevelRepsArray.length - 1 === 0) {
            console.log('inside else if 1:', routine);
            this.getCurrentRoutine(routine,level)

              this.appState.set("allowScreenCount", undefined)
              this.appState.set('fromTodoWidget', true)
            this.openAlertGiveFeedbackCommitmentComponent(routine,level);
          }

        },
        (error) => {
          this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."));
          console.log('Error for feedback ', error)
        }
      )
    }
  }

  checkLastRep(routine: any, level) {
    this.isMobile = this.appState.get('isMobile');
    this.toasterService.success(this.i18n.t('Level Complete!'))
    this.appState.set('LevelNumber', undefined)
    this.appState.set("allLevelsCompleted", true);
    setTimeout(async () => {
     
      const alert = await this.alertController.create({
         cssClass: 'custom-alert-action',
         message: this.i18n.t('Has this routine,')+" "+ routine?.routine_info?.title + " "+ this.i18n.t(", become a habit for you?"),
         
          buttons: [
            {
              text: this.i18n.t("No"),
              cssClass:'custom-alert-textcase',
              handler:()=>{
                this.makeHabit = false
                this.openAlertGiveFeedbackCommitmentComponent(routine,level);
              }
            },
            {
              text: this.i18n.t("Yes"),
              cssClass:'custom-alert',
              handler:()=>{
                this.makeHabit = true
                this.openAlertGiveFeedbackCommitmentComponent(routine,level);
              }
            }
           ],
        });
        await alert.present();
    }, 1000);
  }
  showAnimation() {
    const myConfetti = confetti.create(this.canvas, {
      resize: true // will fit all screen sizes
    });
    myConfetti();

  }
  async openAlertGiveFeedbackCommitmentComponent(routine,level) {
    this.showAnimation()
    this.isMobile = this.appState.get('isMobile');
    this.toasterService.success(this.i18n.t('Habit level Complete!'))
    const modal= await this.modalController.create({
      component: AlertGiveFeedbackCommitmentComponent,
      componentProps: {levelTiltle:level?.title},
      cssClass: this.isMobile ? 'custom-alert-give-feedback-modal' : 'web_routine_feedback_modal',
      enterAnimation: this.animationService.slideInLeftEnterAnimation,
      leaveAnimation: this.animationService.SlideOutRightLeaveAnimation
    })
    this.setModalStack(modal);
    await modal.present();
   modal.onDidDismiss().then((res)=>{
     if(res){
      this.giveFeedback(routine,level)
     }
   })
  }

  levelSwitchCodeCheck(routine, level) {
    let previousLevel = null;
    let currentPath = this.appState.get('currentPath')
    let dailyStepsArray = this.appState.get("DailyStepsData")
    this.isMobile = this.appState.get('isMobile');
    routine?.habits?.forEach((sublevel,index) => {
      if (sublevel.level == level.level) {
        console.log("index", index);
        if (index != 0) {
          for (let i = index - 1; i >= 0; i--) {
            if (!routine.habits[i]?.isHabitCompleted) {
              previousLevel = routine.habits[i];
              break;
            }
          }
        }
      }
    })
    if (this.appState.get('IsRepsAppendAfterReoptCommit') == true) {
        this.appState.set('IsRepsAppendAfterReoptCommit', undefined)
    }
    if (this.appState.get('isLevelClosedBeforeCommit') == true) {
      this.appState.set('isLevelClosedBeforeCommit', undefined) 
    }
    let previousLevelRepsArray;
    if (previousLevel) {
      previousLevelRepsArray = previousLevel?.repsData.filter(item => item.is_completed === false)
    }
    let totalLevelRepsArray, isLastRepLogged , levelTitle
    if (level?.repsData) {
       totalLevelRepsArray = level.repsData.filter(item => item.is_completed === false)
       isLastRepLogged = level.repsData.filter(item => item.is_completed === true)
    }
    else if (level?.repsData) {
       totalLevelRepsArray = level.repsData.filter(item => item?.isCompleted?item?.isCompleted === false :item?.is_completed === false)
       isLastRepLogged = level.repsData.filter(item => item?.isCompleted?item?.isCompleted === true :item?.is_completed === true)
    }
    const last = routine.habits[routine.habits.length - 1];
    this.appState.set('isTodoReps', undefined)
    let unCommittedLevel;
    // let unCommittedLevel = this.getRoutineLockedLevel(routine)
     if (level?.isHabitUnlocked == false) {
      unCommittedLevel = this.getRoutineUnselectedLevel(routine);
    }
    else {
      unCommittedLevel = this.getRoutineLockedLevel(routine)
    }
    if (unCommittedLevel?.level && (last.id !== level.id || !level.isHabitUnlocked)) {
      if (level?.isHabitUnlocked == true && unCommittedLevel) {
        this.appState.set('LevelNumber', unCommittedLevel?.level)
        this.appState.set('unCheckedLevelId',unCommittedLevel?.level?.id?unCommittedLevel?.level?.id:unCommittedLevel?.id );
        levelTitle = unCommittedLevel?.level?.title?  unCommittedLevel?.level?.title: unCommittedLevel?.title
      }
      else {
        this.appState.set('LevelNumber', level.level)
        this.appState.set('unCheckedLevelId',level?.id);
        levelTitle = unCommittedLevel?.level?.title? unCommittedLevel?.level?.title: unCommittedLevel?.title;
      }
      this.appState.set('levelUpdated', true)
      this.getCurrentRoutine(routine,level)
      this.appState.set('showUpdatedScreens', true)
      let unlockingHabitStepDetails = currentPath.findChapterStepByScreenContentId(dailyStepsArray, routine?.screenContentId)
      console.log("unlocking HabbitStepDetails", unlockingHabitStepDetails)
      let routineDay = unlockingHabitStepDetails?.stepPosition
      localStorage.setItem('unlockingHabitStepDetails', JSON.stringify(unlockingHabitStepDetails))
      this.appState.set('isLevelClosedBeforeCommit', true)
      if (routine.pathId === currentPath.id) {
        this.appState.set('isLevelCommited', false);
        this.appState.set("allowScreenCount", undefined)
         if (this.isMobile) {
            this.appState.set('UnlockedLevelTitle',levelTitle)
            this.route.navigate(["/alert-unlock-component"], {
          state: {
            data: routineDay
          },
        });
        } else {
           this.commitService.closeModals()
           this.appState.set('UnlockedLevelTitle',levelTitle)
            this.appState.set('UnlockedLevelTitle',levelTitle)
            setTimeout(() => {
              this.openDailyStepsComponent(AlertUnlockLevelComponent, { nextLevelData:  routineDay }, 'web-daily-steps-custom-modal')
            }, 1100);
        }
        this.appState.set("levelUpdateData", undefined);  
      } else {
        this.changeSubPath(routine.pathId, routineDay,'daily-content-screen-routine', this.appState.get("isNotificationViewed")==false?true:false, levelTitle)
      }
    }
  }
   async routineRepeatForLevel(routine,level) {
       const alert = await this.alertController.create({
               
                 cssClass: 'habit-alert',
                 message: this.i18n.t('Do you want to continue building this habit for the next week?'),
                  buttons: [
                    {
                      text: this.i18n.t("No"),
                      cssClass:'custom-cancle-btn',
                      handler:()=>{
                       this.levelSwitchCodeCheck(routine,level)
                      }
                    },
                    {
                      text: this.i18n.t("Yes"),
                      cssClass:'custom-yes-alert',
                      handler: () => {
                        this.reoptTheLevelCue(routine,level)
                      }
                    }
                   ],
                });
                await alert.present();
 }

  async reoptTheLevelCue(routine, level) {
        const modal= await this.modalController.create({
          component: ReoptHabitLevelModalComponent,
          cssClass: 'reopt-habit-level-modal',
      componentProps: {data: {
                dataKey: { routine: level },
              }},
      backdropDismiss:false
    })
    await modal.present();
            modal.onWillDismiss().then((result) => {
              console.log("result", result);
              var routineAnswer = level.commitmentStatement;
              if (result?.data?.status === "confirm") {
                this.findLevelId(routine,level,false)
                if (level) {
                  if (level.isSingleEvent === null) {
                    this.commitService.earlierOptedNotsureTimesDays(routineAnswer,
                      routine,
                      level,level?.isSingleEvent)
                  }
                  else {
                    this.commitService.sameCueOptSelection(level.isSingleEvent,
                      routineAnswer,
                      routine,
                      level)
                  }
                  this.appState.set("isConfirmed", true);
                }
              } else if (result?.data?.status === "change") {
                //No, change cue
                this.appState.set("changeCue", true);
                this.appState.set("isRoutineEdited", true);
                this.appState.set('levelEdit', true)
                 this.onSubmit(routine,level,false)
              } else if (result?.data?.status === "turnOff") {
                //No, turn off reminders, switch to next level if present
                this.levelSwitchCodeCheck(routine,level)
              }
            });
  }

  
  giveFeedback(routine: any, level) {
    this.routineList= this.appState.get('todoRoutines')
    routine = this.getRoutineByLevel(level, this.routineList)
    let currentLevelIndex= routine?.habits?.findIndex(item => item.id === level?.id);
    level = routine?.habits[currentLevelIndex]
    var step_rating = localStorage.getItem("commitmentRating1")
    var step_comment = localStorage.getItem("commitmentFeedback")
    try {
      const requestData = {
        // 'user_id': routine.user_id,
        // 'path_id': routine.path_id,
        // 'step_score': step_rating,
        // 'step_comment': step_comment,
        // 'routine_info_id': routine.routine_info_id,
        // 'is_routine_complted':routine?.routine?.length>0?(routine?.routine[routine?.routine?.length-1]?.is_level_completed?true:false):(routine?.levels?.length>0?routine?.levels[routine?.levels?.length-1]?.is_level_completed?true:false:false)
        habit_group_id: routine.habitGroupId,
        habit_id: level.id,
        is_habit_completed: routine?.habits?.length > 0 &&routine.habits.filter(habit => habit?.isHabitCompleted).length === routine.habits.length,
        habit_rating: step_rating,
        habit_feedback: step_comment
      }
      if (requestData.habit_feedback == '' && requestData.habit_rating == '') {
      } else {
        this.routineService.routineFeedback(requestData).subscribe(
          async (response) => {
            console.log('response', response)
            this.kyperApiService.getHabits(routine.pathId);
            if (step_rating == '5') {
              this.levelSwitchCodeCheck(routine, level);
            }

            else {
               this.routineRepeatForLevel(routine,level)
            }
          },
          (error) => {
            this.toasterService.error(this.i18n.t('Server or connection issue. Please check your internet connection.'))
          }
        )
      }
    } catch (o_O) {
      console.log(o_O);
    }
  }
  
  onSubmit(routine, level, isNotificationEnabled) {
     let checkUnfinishedLevels =this.getUnFinishedLevelBeforeRecommit(routine)
    if (checkUnfinishedLevels && checkUnfinishedLevels?.length > 0) {
      this.toasterService.warning(this.i18n.t('Please complete uncompleted level reps in To-Do list section before re-commit.'))
    }
    else {
      let currentPath = this.appState.get('currentPath')
      let dailyStepsArray= this.appState.get("DailyStepsData");
      this.appState.set('showUpdatedScreens', true)
      this.appState.set('LevelNumber', level.level)
      this.findLevelId(routine, level,isNotificationEnabled)
      this.appState.set('levelUpdated', true)
      this.appState.set('hidePrevScreen', true);
      this.appState.set("allowScreenCount", undefined)
      let unselectedIndex = routine.habits.findIndex(item => item.id === level.id);
      this.appState.set('indexOfLevel', unselectedIndex)
       let unlockingHabitStepDetails = currentPath.findChapterStepByScreenContentId(dailyStepsArray, routine?.screenContentId)
      console.log("unlocking HabbitStepDetails", unlockingHabitStepDetails)
      let routineDay = unlockingHabitStepDetails?.stepPosition
      if (routine.pathId === currentPath.id) {
         this.appState.set("reviewingStepIndex", unlockingHabitStepDetails?.stepIndex);
          let chapterPosition= unlockingHabitStepDetails?.chapterIndex
        this.dismissAllModals().then(() => {
          if (this.appState.get('isMobile')) {
            this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: 'daily-content-screen-meet-cue', currentOpenedChapter: chapterPosition, currentOpenedStep: unlockingHabitStepDetails?.stepIndex } })
          }
          else {
            this.modalController.dismiss()
            this.openDailyStepsComponent(DailyStepsContentWebModalV2Component, { currentDay: routineDay, startFromScreen: 'daily-content-screen-meet-cue',currentOpenedChapter:chapterPosition }, 'web-daily-steps-custom-modal')
          }
        })
      }
      else {
        localStorage.setItem('unlockingHabitStepDetails', JSON.stringify(unlockingHabitStepDetails))
        this.changeSubPath(routine.pathId, routineDay,'daily-content-screen-meet-cue',this.appState.get("isNotificationViewed")==false?true:false)
      }
    }
  }

  findLevelId(routine: any, checkedLevel: any, isNotificationEnabled) {
    let someArray = []
    let level_ids = [];
    routine.habits.forEach(element => {
      if (element.id == checkedLevel.id) {
        someArray.push(element)
        level_ids.push(element.id)
      }
    });
    if (!isNotificationEnabled) {
      this.appState.set('IsRepsAppendAfterReoptCommit',true)
    }
    this.appState.set('LevelNumber', someArray[0].level)
     let unselectedIndex = routine.habits.findIndex(item => item.id === checkedLevel.id);
    this.appState.set('indexOfLevel', unselectedIndex) 
    this.appState.set('currentLevel', someArray[0])
    this.appState.set('levelUpdated', undefined);
  }
fetchScreenTypeContent(screentype) {
    let dailyStepsArray= this.appState.get("DailyStepsData");
    return dailyStepsArray
  .map(step => step?.[screentype])
  .filter(s => s != null && (Array.isArray(s) ? s?.length > 0 : true))
  .flatMap(s => Array.isArray(s) ? s : [s]);
  }
  resetLevelEnabledStatus(routine, level) {
    let unCheckedLevels = [];
    let selectedLevels = []
    let routineInfo = this.appState.get('todoRoutines')
    routineInfo.forEach(currentRoutine => {
      if (currentRoutine.habitGroupId === routine.habitGroupId) {
        currentRoutine.habits.forEach(routineLevel => {
            const match = currentRoutine.habits.filter((level) => level.id === routineLevel.id)
            if (level.id == routineLevel.id && (match.length === 1)) {
               routineLevel.enabled = false;
              unCheckedLevels.push({ 'id': routineLevel.id, 'index': currentRoutine.habits.indexOf(routineLevel) })
            }
            else {
              let index;
              if (routine?.habits?.length > 0) {
                index= routine?.habits?.findIndex(item => item?.id === routineLevel.id)
              }
              if (routine?.levels?.length > 0) {
                index= routine?.habits?.findIndex(item => item?.id === routineLevel.id)
              }
              if (index) {
                routineLevel.enabled = true;
                selectedLevels.push({ 'id': routineLevel.id, 'index': currentRoutine.habits.indexOf(routineLevel) })
             }
              
            }
        });
      }
    
    });
      unCheckedLevels= unCheckedLevels.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id));
    this.appState.set('unCheckedLevels', [...new Set(unCheckedLevels)])
    selectedLevels = [...new Set(selectedLevels)]
    this.appState.set('selectedLevelIds', selectedLevels)
    console.log('selected ad unselected levels',unCheckedLevels, selectedLevels)
  }

  getCurrentRoutine(routine, level) {
    let unCheckedLevels = [];
    let selectedLevels = []
    let routineInfo =  this.appState.get("todoRoutines")
   // routineInfo.forEach(currentRoutine => {
      // if (currentRoutine.habitGroupId === routine.habitGroupId) {
      //   currentRoutine.habits.forEach(routineLevel => {
      //     routine.habits.forEach(myLevel => {
      //       const match = routine.habits.filter((level) => level.id === routineLevel.id)
      //       if (myLevel.id !== routineLevel.id && (match.length === 0)) {
      //          myLevel.enabled = false;
      //         unCheckedLevels.push({ 'id': routineLevel.id, 'index': currentRoutine.habits.indexOf(routineLevel) })
      //       }
      //     });
      //   });
      //   unCheckedLevels = [...new Set(unCheckedLevels)];
    // }
    routine.habits.forEach(myLevel => {
      const match = routine.selectedHabitIds?.includes(myLevel.id)
      if (myLevel.id!=level.id  && (match.length === 0 && routine.selectedHabitIds?.length!=0)) {
        // myLevel.enabled = false;
        myLevel.enabled = false;
        unCheckedLevels.push({ 'id': myLevel.id, 'index': routine.habits.indexOf(myLevel) })
        unCheckedLevels = [...new Set(unCheckedLevels)];
      }
      let unselectedIndex = routine.habits.findIndex(item => item.id === level.id);
      let unCommittedLevel, unCommitedIndex;
      unCommittedLevel = this.getRoutineLockedLevel(routine)
      if (level?.isHabitUnlocked == true && unCommittedLevel) {
        unCommitedIndex = routine.habits.findIndex(item => item.id === unCommittedLevel?.id);
        this.appState.set('indexOfLevel', unCommitedIndex)
      }
      else {
         this.appState.set('indexOfLevel', unselectedIndex)
      }
    });
    this.appState.set('unCheckedLevels', [...new Set(unCheckedLevels)])
    unCheckedLevels= unCheckedLevels.filter((value, index, self) => index === self.findIndex((t) => t.id === value.id));
    routine.habits?.forEach(element => {
       let isPresentInUncheckedLevel = unCheckedLevels?.findIndex(item => item?.id === element.id)
      // if (!element.enabled && isPresentInUncheckedLevel ==-1) {
      //   element.enabled = true;
      //   selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      // }
      //  else if(element.enabled) {
      //    selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      // }

       if (!routine.selectedHabitIds?.includes( element.id) && element.id ==level.id) {
        element.enabled = true;
        selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      }
       else if(routine.selectedHabitIds?.includes( element.id) || routine.selectedHabitIds?.length==0) {
         selectedLevels.push({ 'id': element.id, 'index': routine.habits.indexOf(element) })
      }
    });
    selectedLevels = [...new Set(selectedLevels)]
    this.appState.set('selectedLevelIds', selectedLevels)
  }

  refresh() {
    return new Promise(resolve => {
      // here to fetch the data and rerender the contents.
      this.appState.refreshMainComponent.emit()
      setTimeout(resolve, 0)
    })
  }

  /**
   * Moves the learner to another cycle and leaves them on their home screen.
   *
   * changeSubPath below does the same switch and then deep-links to a particular step — it needs a
   * routine day and chapter/step positions to do that. A caller who only knows WHICH cycle, such as
   * a micro-action opened from History, has none of those, and sending junk into that navigation is
   * worse than not navigating at all.
   *
   * The state cleared here is the same set: stale step data left behind renders the previous
   * cycle's content under the new cycle's name.
   */
  switchCycle(
    pathId: number | string,
    handlers: { onSwitched?: () => void | Promise<any>; onFailed?: () => void } = {},
  ): void {
    const request = {
      'user_id': this.appState.get('currentUser')?.id,
      'active_path_id': pathId,
    };
    this.homev5Service.subpathchange(request, 'Switch cycles from micro-action tab in conversation history modal').subscribe(
      (response) => {
        // The caller goes first, and is waited for: only it knows what it put on screen — modals
        // over the home screen, a request it stored for the other side of the reload — and only it
        // can take that down in the right order. Doing it before this request answered left a
        // failure with everything already dismissed and a pending request that never came due.
        Promise.resolve(handlers.onSwitched?.()).then(() => this.applySwitchedCycle(response));
      },
      (error) => {
        console.log('Response of path changed ', error);
        // Nothing has been torn down: the caller is still on screen and can say so.
        handlers.onFailed?.();
      },
    );
  }

  /** The reload half of the switch, once the server has agreed to it and the caller has made way. */
  private applySwitchedCycle(response: any): void {
    this.appState.set('isAllPaths', false);
    this.appState.set('screensViewed', undefined);
    this.appState.set('stepsArray', undefined);
    this.appState.set('stepObject', undefined);
    this.appState.set('allowScreenCount', undefined);
    this.appState.set('levelUpdated', true);
    this.refresh();

    const data = response?.['data'];
    const onboarding = data?.onboardingSurvey || data?.isIntroVideo;
    const completedFlags = data?.isonboardingcompleted;
    const pending = Array.isArray(completedFlags)
      && onboarding
      && (completedFlags.length === 0 || completedFlags[0]?.isonboardingcompleted !== true);
    if (pending) {
      // A cycle whose onboarding has not been done starts there, not on a home screen that has
      // nothing on it yet.
      this.route.navigate(['/onboarding'], {
        state: { onboardingSurvey: data?.onboardingSurvey, isIntroVideo: data?.isIntroVideo },
      });
      return;
    }
    this.checkSubpathStatus();
    this.route.navigate(['/main']);
  }

  changeSubPath(pathId: number, routineDay: number,startFromScreenId, isNotificationsAvailable, levelTitle?) {
    this.isMobile = this.appState.get('isMobile');
    const request = {
      'user_id': this.appState.get('currentUser').id,
      'active_path_id': pathId
    }

    this.homev5Service.subpathchange(request, 'From Action hub EOS/side bar menu section').subscribe(
      (response) => {
        this.appState.set('isAllPaths', false)
        this.appState.set("screensViewed", undefined);
        this.appState.set('stepsArray', undefined)
        this.appState.set('stepObject', undefined)
        this.refresh()
        let data = response["data"];
        try {
          let isOnboardContentPresent = data.onboardingSurvey || data?.isIntroVideo;
          if (data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted?.length > 0 && isOnboardContentPresent) {
            let value = data['isonboardingcompleted'][0];
            this.isonboardingcompleted = value["isonboardingcompleted"];
            if ((this.isonboardingcompleted === false || this.isonboardingcompleted === null) && isOnboardContentPresent) {
              this.route.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          

            } else if (this.isonboardingcompleted === true) {
              this.appState.set("allowScreenCount", undefined)
              this.appState.set('levelUpdated', true);
              if (isNotificationsAvailable) {
                this.appState.set("isAllNotificationNotViewedAfterPathSwitch",true)
              }
              if (levelTitle && !isNotificationsAvailable) {
                this.appState.set('isLevelClosedBeforeCommit', true)
              }
              let stepIndex =JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex
              this.appState.set("reviewingStepIndex", stepIndex);
              let chapterPosition= JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.chapterIndex
              localStorage.removeItem('unlockingHabitStepDetails')
              if (this.isMobile) {
                setTimeout(() => {
                  this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: startFromScreenId, currentOpenedChapter: chapterPosition, currentOpenedStep: stepIndex } })
                }, 3500);
              }
              else {
              setTimeout(()=>{
                this.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: routineDay,startFromScreen: startFromScreenId,currentOpenedChapter:chapterPosition},'web-daily-steps-custom-modal')
                },3800);
              }
            }
          } else if(data?.isonboardingcompleted.constructor === Array && data?.isonboardingcompleted.length===0 && isOnboardContentPresent){
              this.route.navigate(["/onboarding"], { state: { onboardingSurvey: data.onboardingSurvey, isIntroVideo: data?.isIntroVideo } });                          
          } else {
            this.appState.set("allowScreenCount", undefined)
            this.appState.set('levelUpdated', true);
            this.checkSubpathStatus();
              if (levelTitle && !isNotificationsAvailable) {
                this.appState.set('isLevelClosedBeforeCommit', true)
              }
              if (isNotificationsAvailable) {
                this.appState.set("isAllNotificationNotViewedAfterPathSwitch",true)
              }
            let stepIndex =JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex
             this.appState.set("reviewingStepIndex", stepIndex);
              let chapterPosition= JSON.parse?.(localStorage.getItem('unlockingHabitStepDetails'))?.chapterIndex
              localStorage.removeItem('unlockingHabitStepDetails')
            console.log("entering final else block");
            if (this.isMobile) {
              setTimeout(() => {
                this.route.navigate(['/content', routineDay], { queryParams: { startFromScreen: startFromScreenId , currentOpenedChapter: chapterPosition,currentOpenedStep:stepIndex} })
              }, 3500);
            }
            else {
              setTimeout(()=>{
                this.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: routineDay,startFromScreen: startFromScreenId,currentOpenedChapter:chapterPosition},'web-daily-steps-custom-modal')
              },3800);
            }
          }
        } catch (error) {
          this.route.navigate(['/main']);
        }
        this.refresh()
      }, (error) => {
        console.log("Response of path changed ", error)
      }
    )
  }

  async expandOnEnterAnimation() {
    const animation = this.animationCtrl.create()
      .addElement(document.getElementById('content'))
      .duration(200)
      .keyframes([
        { offset: 0, transform: 'scale(0)' },
        { offset: 1, transform: 'scale(1)' }
      ]);

    await animation.play();
  }
  getModalStack() {
    return this.modalStack;
  }
  getLastModal() {
   return this.modalStack.pop();
  }
  async dismissTopModal() {
    this.modalStack =this.getModalStack();
    if (this.modalStack.length > 0) {
      // Dismiss the top modal in the stack
      const modal = this.modalStack.pop();
      await modal.dismiss();
    }
  }
  /**
   * Persist a screen's completion to the SERVER (same endpoint the content/text screens use)
   * AND into the in-memory DailyStepsData + currentPath.kyperChapters, so the completion sticks
   * across an in-step close/reopen and is loaded back on future cycles. Mirrors the text-screen
   * pattern. Screens are located by screenContentId.
   */
  markScreenCompleted(stepId: any, screenId: any, screenContentId: any, screenRef?: any) {
    if (screenContentId == null) { return; }
    // Skip the round-trip when this screen is already marked completed (returning cycle / re-save),
    // but still reflect the (already server-confirmed) completion on the caller's own screen ref.
    if (this.isScreenCompleted(screenContentId)) {
      if (screenRef?.screen) { screenRef.screen.isCompleted = true; }
      return;
    }
    // Reflect completion in LOCAL state (isCompleted → true in DailyStepsData AND
    // currentPath.kyperChapters, so it survives an in-step close/reopen) AND stamp the caller's own
    // screen-data reference (learningScreenData / managerEmailScreenData / accountabilityEmailData),
    // ONLY AFTER the completion endpoint confirms — keep every copy of the flag in lock-step with
    // what the server actually stored.
    this.kyperApiService.updateContentScreenCompletion({ stepId, screenId, screenContentId }).subscribe(
      () => {
        this.appState.persistScreenContent({ isCompleted: true }, { screenContentId });
        if (screenRef?.screen) { screenRef.screen.isCompleted = true; }
      },
      () => {
        mixpanel.track("screen saving was failed",{screen:screenRef})
        // this.toasterService.error(this.i18n.t("Server or connection issue. Please check your internet connection."));
      }
    );
  }

  /** True when the screen identified by screenContentId is already flagged completed in the
   *  in-memory step data (DailyStepsData or currentPath.kyperChapters). */
  private isScreenCompleted(screenContentId: any): boolean {
    const scan = (chapters: any[]) => (chapters || []).some((chapter: any) =>
      (chapter?.steps || []).some((step: any) =>
        (step?.screens || []).some((screen: any) =>
          screen?.screenContents?.id === screenContentId && !!screen?.screenContents?.isCompleted)));
    return scan(this.appState.get('DailyStepsData')) ||
      scan(this.appState.get('currentPath')?.kyperChapters);
  }

saveManagerEmailAddress(answers,managerEmail,currentDay?,screenContentId?,stepId?,screenId?: any,screenRef?: any,managerEmails?: string[],isAdd: boolean = true) {
     this.surveyService.saveAnswers(answers,managerEmail,currentDay,null,screenContentId,stepId,managerEmails).subscribe(
      (result) => {
         console.log("result", result);
         // Expose the manager email as the mandatory-gate signal only now that the server has
         // stored it (host reads appState 'managerEmail' into addedManagerEmail via ngDoCheck).
         this.appState.set("managerEmail", managerEmails ? managerEmails[0] : managerEmail);
         // Persist screen completion (server + state + the caller's managerEmailScreenData ref) so
         // the screen stays "done" on THIS path even if a manager is later removed, and is restored
         // on reopen / future cycles. Only on add: removing a manager must not re-lock a screen that
         // was already marked done (mirrors pushAccountablityEmails()'s isAdd-only completion).
         if (isAdd) {
           this.markScreenCompleted(stepId, screenId, screenContentId, screenRef);
         }
         this.toasterService.success(this.i18n.t(isAdd ? "Manager email confirmed" : "Manager email removed"))
      }
    );
  }
  async openNextComponent(comp?, compProps?,className?){
 
    if (comp) {
      const modal = await this.modalController.create({
        component: comp,
        componentProps: compProps,
        cssClass: className?className:'custom-modal',
        enterAnimation: this.animationService.slideInLeftEnterAnimation,
        leaveAnimation: this.animationService.SlideOutRightLeaveAnimation
      });
      await modal.present();
      modal.onDidDismiss().then((data) => {
        this.currentUser = this.appState.get('currentUser')
        this.path = this.appState.get('currentPath')
        if (this.appState.get('IsRepsAppendAfterReoptCommit') == true && comp != MyCommitmentsComponent) {
          this.closingModalOnClickingBackground();
        }
        if (this.appState.get('isLevelClosedBeforeCommit') == true && comp != MyCommitmentsComponent) {
          this.closingModalOnClickingBackgroundForUnLockedCommit();
        }
        if (data?.data?.nextHabitUnlockFromToDoScreen == 'nextHabitUnlockFromToDoScreen') {
          setTimeout(() => {
            this.openDailyStepsComponent(DailyStepsContentWebModalV2Component, { currentDay: data?.data?.currentDay, startFromScreen: 'daily-content-screen-todo' }, 'web-daily-steps-custom-modal');
          }, 600);
        }
        if (data?.data?.isInstepTodoScreen) {
          this.unlockNextHabitLevel();
        }
        if (!this.appState.get("isNotificationViewed")) {
          this.getAllRoutines(this.path.id)
        }
        if (data?.data?.isAlertUnlockClosed) {
          let stepIndex=JSON.parse(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex
          this.appState.set("reviewingStepIndex", stepIndex);
          let chapterPosition= JSON.parse(localStorage.getItem('unlockingHabitStepDetails'))?.chapterIndex
          this.appState.set('isLevelClosedBeforeCommit', true)
          localStorage.removeItem('unlockingHabitStepDetails')
          this.openDailyStepsComponent(DailyStepsContentWebModalV2Component, { currentDay: data?.data?.currentDay, startFromScreen: 'daily-content-screen-routine-sub-level',currentOpenedChapter:chapterPosition, currentOpenedStep:stepIndex }, 'web-daily-steps-custom-modal')
        }
      })
    }
   
   }
   async dismissAllModals() {
    // Retrieve the list of active modals and dismiss them one by one
    let activeModals;
    activeModals= this.getModalStack()
    activeModals?.forEach(async (modal) => {
      await modal.dismiss();
    });
  }

  public updateDates(data): Observable<any>{
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    return this.httpclient.put(this.API_URL+this.UPDATE_DATES, data,{headers});
  }

  public fetchDailyStepsStatus(data) : Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    const params = new HttpParams().append('user_id', data.user_id)
                                   .append('path_id', data.path_id);
    return this.httpclient.get(this.API_URL + this.GET_DAILY_STEPS_STATUS, { headers, params }).pipe(
      map(response => {
        return response
      })
    )
    
  }
  public fetchDailyChaperStepsStatus() : Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    return this.httpclient.get(this.API_URL + this.GET_KYPER_CHAPTER_STEPS_STATUS, { headers }).pipe(
      map(response => {
        return response
      })
    )
    
  }

  getCurrentDate() {
     const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0'); // Add 1 and pad with '0' if single digit
    const day = currentDate.getDate().toString().padStart(2, '0');
    const formattedDate = `${year}-${month}-${day}`;
    return formattedDate;
  }

  public fetchDailyStreaksInfo(data): Observable<any> {
    const input = {
      step_number: data,
      current_date: this.getCurrentDate()
    }
    mixpanel.track("Streaks input data before marking today's streak",{streakInput: input})
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.httpclient.post(this.API_URL + this.GET_DAILY_STREAKS_INFO, input, { headers }).pipe(
      map(response => {
        return response
      })
    )
    
  }
  
   public fetchChaptersInfo(input): Observable<any> {
 
    mixpanel.track("Chapters input data before saving shiffled order",{chapterInput: input})
    const headers = new HttpHeaders();
    headers.set("Authorization", localStorage.getItem("token"));  
    return this.httpclient.post(this.API_URL + this.GET_CHAPTERS_INFO, input, { headers }).pipe(
      map(response => {
        return response
      })
    )
    
  }
  getStreaksInfo(stepNumber) {
    this.fetchDailyStreaksInfo(stepNumber).subscribe((data)=>{
      this.appState.set('dailyStreaksInfo', data?.data);
    })
  }

  // convertPlainObjectToModalType(data: DailySteps[]): DailySteps[] {
  //   return data?.map(stepData => {
  //       const dailyStep = new DailySteps(stepData);
  //       Object.assign(dailyStep, stepData);
  //       if (stepData.habits) {
  //         dailyStep.habits = new Habit(stepData.habits);
  //         Object.assign(dailyStep.habits, stepData.habits);
  //       }
  //       if (stepData.documents) {
  //         dailyStep.documents = new Document(stepData.documents);
  //         Object.assign(dailyStep.documents, stepData.documents);
  //       }
  //       if (stepData.contentSurveys) {
  //         dailyStep.contentSurveys = new ContentSurvey(stepData.contentSurveys);
  //         Object.assign(dailyStep.contentSurveys, stepData.contentSurveys);
  //       }
  //       if (stepData.inoutScreens) {
  //         dailyStep.inoutScreens = new InoutScreen(stepData.inoutScreens);
  //         Object.assign(dailyStep.inoutScreens, stepData.inoutScreens);
  //       }
  //       if (stepData.questions) {
  //         dailyStep.questions = new Question(stepData.questions);
  //         Object.assign(dailyStep.questions, stepData.questions);
  //       }
  //       if (stepData.reflections) {
  //         dailyStep.reflections = new Reflection(stepData.reflections);
  //         Object.assign(dailyStep.reflections, stepData.reflections);
  //       }
  //       if (stepData.routineInfo) {
  //         dailyStep.routineInfo = new RoutineInfo(stepData.routineInfo);
  //         Object.assign(dailyStep.routineInfo, stepData.routineInfo);
  //       }
  //     if (stepData.toDos) {
  //         dailyStep.toDos = new TodoListModel(stepData.toDos);
  //         Object.assign(dailyStep.toDos, stepData.toDos);
  //       }
  //       if (Array.isArray(stepData.polls) && stepData.polls.length > 0) {
  //         dailyStep.polls = stepData.polls.map(p => {
  //           const poll = new Poll(p);
  //           Object.assign(poll, p);
  //           return poll;
  //         });
  //       }
  //       if (Array.isArray(stepData.onboardingSteps) && stepData.onboardingSteps.length > 0) {
  //         dailyStep.onboardingSteps = stepData.onboardingSteps.map(s => {
  //           const onboardingStep = new OnboardingSteps(s);
  //           Object.assign(onboardingStep, s);
  //           return onboardingStep;
  //         });
  //       }
  //       return dailyStep;
  //     });
  // }

//   updateStepStatusFromApi(data) {
//   const originalStepsData = this.appState.get("DailyStepsData");

//   if (!originalStepsData || !Array.isArray(originalStepsData) || this.appState.get('isPathPersonalized')) {
//    this.appState.set('isPathPersonalized',false)
//     return this.convertPlainObjectToModalType(data || []);
//   }

//   data?.forEach((step) => {
//     const originalStep = originalStepsData.find(s => s.step === step.step);
//     if (originalStep) {
//       originalStep.stepStatus = step.stepStatus;
//     }
//   });
//   return originalStepsData;
// }

  getDailyStepsInfo(){
    this.fetchDailyChaperStepsStatus().subscribe(
      (data) => {
        if(data?.chapters) {
          const deselected = data?.deselectedChapters ?? data?.deselected_chapters;
          const userChapter = data?.userChapter ?? data?.user_chapter;
          this.refetchChapterSteps(data?.chapters, data?.streaks, data?.currentChapter, deselected, userChapter);
        } else {
          this.emitLoadedStepData();
        }
      },
      () => { this.emitLoadedStepData(); }
    );
  }

  private emitLoadedStepData() {
    const chapters = this.appState.get('DailyStepsData');
    if (chapters?.length > 0) {
      this.setRelationshipState({
        data: chapters,
        streaks: this.appState.get('dailyStreaksInfo'),
        currentChapter: this.appState.get('currentChapterInfo'),
      });
    }
  }

  clearPendingChaptersOrder() {
    this.appState.set('pendingChaptersOrderInput', null);
    this.appState.set('chaptersOrderSavedFlag', false);
  }

  saveAndClearPendingChaptersOrder() {
    const input = this.appState.get('pendingChaptersOrderInput');
    if (input) {
      this.fetchChaptersInfo(input).subscribe(
        (res) => {
          // Only clear pendingChaptersOrderInput if it hasn't been replaced by a newer drag
          // since this API call was initiated (reference equality guards against stale responses)
          if (this.appState.get('pendingChaptersOrderInput') === input) {
            this.appState.set('pendingChaptersOrderInput', null);
          }
          this.appState.set('chaptersOrderSavedFlag', false);
          const data = res?.data ?? {};
          const allOrder: number[] = data?.chapter_order ?? data?.chapterOrder;
          const selectedIds: number[] = data?.selected_chapter_ids ?? data?.selectedChapterIds;
          let shuffledOj;
          if (this.appState.get('currentPath')?.enabledAttributes?.chapter_skip) {
            shuffledOj = {
              chapterOrder: allOrder,
              id: data?.chapter_id ?? data?.chapterId,
              stepsCompletedInChapter: data?.steps_completed_in_chapter ?? data?.stepsCompletedInChapter ?? 0,
              selectedChapterIds: selectedIds,
              isFinalised: data?.is_finalised ?? data?.isFinalised
            };
          } else {
            shuffledOj = {
              chapterOrder: allOrder,
              id: data?.chapter_id ?? data?.chapterId,
              stepsCompletedInChapter: data?.steps_completed_in_chapter ?? data?.stepsCompletedInChapter ?? 0,
              isFinalised: data?.is_finalised ?? data?.isFinalised
            };
          }
          this.appState.set('userShuffledChapters', shuffledOj);
        },
        (err) => {
          mixpanel.track("Error saving chapters order on parent dismiss", { InputParams: input, err });
          this.clearPendingChaptersOrder();
        }
      );
    } else {
      this.appState.set('chaptersOrderSavedFlag', false);
    }
  }

  applyChapterPersonalizationToAppState(deselectedChapters: any, userChapter: any) {
    const path = this.appState.get('currentPath');
    if (Array.isArray(deselectedChapters) && path) {
      path.deselectedChapters = deselectedChapters;
    }
    if (userChapter) {
      const allOrder = userChapter.chapterOrder ?? userChapter.chapter_order;
      if (Array.isArray(allOrder)) {
        const normalized: any = {
          chapterOrder: allOrder,
          id: userChapter.id ?? userChapter.chapter_id,
          stepsCompletedInChapter: userChapter.stepsCompletedInChapter
            ?? userChapter.steps_completed_in_chapter
            ?? userChapter.step_completed_in_chapter
            ?? 0,
          selectedIds:userChapter.selectedChapterIds ?? userChapter.selected_chapter_ids,
          isFinalised: userChapter.is_finalised ?? userChapter.isFinalised
        };
        const selectedIds = userChapter.selectedChapterIds ?? userChapter.selected_chapter_ids;
        if (Array.isArray(selectedIds)) {
          normalized.selectedChapterIds = selectedIds;
        }
        this.appState.set('userShuffledChapters', normalized);
        path.userChapter = normalized;
        this.appState.set('currentPath',path);
        if (path) { path.userChapter = normalized; }
      }
    }
  }

  refetchChapterSteps(chapters, streaks, currentChapter, deselectedChapters?: any, userChapter?: any, emitToSubscribers: boolean = true) {
    let dailyChapterSteps: KyperChapters[] = [];
    let path = this.appState.get('currentPath');
    let presentChapters = this.appState.get("DailyStepsData")
    // if (presentChapters?.length > 0) {

    //   // dailyChapterSteps = chapters?.map((ch, i) => ({
    //   //   ...ch,
    //   //   steps: ch.steps?.map((step, j) => ({
    //   //     ...step,
    //   //     screens: presentChapters?.[i]?.steps?.[j]?.screens
    //   //   }))
    //   // }));
    // }
    // else {
      dailyChapterSteps = chapters
    //}

    let stepPosition = dailyChapterSteps[currentChapter.position]?.steps[currentChapter?.currentStep?.chapterStepIndex];
    if (stepPosition?.stepStatus == 'Review' && currentChapter?.currentStep?.position == path.lastDayOfContent()) {
      this.appState.set('scheduleDayForCurrentStep', stepPosition?.position + 1);
      this.appState.set("currentScheduleDay", stepPosition?.position + 1);
    }
    else {
      this.appState.set('scheduleDayForCurrentStep', stepPosition?.position);
      this.appState.set("currentScheduleDay", stepPosition?.position);
    }
    this.appState.set('reviewingStepIndex',  currentChapter?.currentStep?.chapterStepIndex);
    console.log("Step count after review status update:", currentChapter.position, currentChapter);
    this.appState.set('currentActiveChapter', currentChapter.position);
    this.appState.set('currentActiveStepIndex', currentChapter?.currentStep?.chapterStepIndex);
    this.appState.set("DailyStepsData", dailyChapterSteps);
    if (emitToSubscribers) {
      this.setRelationshipState({ data: dailyChapterSteps, streaks: streaks?streaks:this.appState.get('dailyStreaksInfo'), currentChapter: currentChapter });
    }
    console.log("streaks info in dailyStepsStaus func", dailyChapterSteps, streaks)
    mixpanel.track("Streaks info storing after api fetch", { streaksInfo: streaks?streaks:this.appState.get('dailyStreaksInfo'), dailyStepsData: dailyChapterSteps })
    this.appState.set('currentChapterInfo', currentChapter);
    this.appState.set('dailyStreaksInfo', streaks ? streaks : this.appState.get('dailyStreaksInfo'))
    this.applyChapterPersonalizationToAppState(deselectedChapters, userChapter);
  }

  setRelationshipState(val) {
    this.apiStepDataSubject.next(val);
  }

  resetStepApiData() {
    this.apiStepDataSubject.next(null);
  }
 
  getAllRoutines(pathId: number) {
    const requestData = {
      path_id: pathId,
    };
    this.kyperApiService.getHabitsList(requestData).subscribe(
      (response) => {

        this.appState.set('todoRoutines', this.homev5Service.removeDuplicates(response.habits, "habitGroupId"))
        // this.appState.set('todoActions', response.data[0].action)

        this.routineList = this.homev5Service.removeDuplicates(
          response.habits,
          "habitGroupId"
        );
        var notificationSentArrayLevel = this.routineList.map((item) => {
          return {
            ...item,
            originalRoutine: item.habits,
            routine: item.habits.filter(
              (routine) => routine.habitNotificationSent === true
            ),
          };
        });
        var notificationSentArrayLevelFinal = notificationSentArrayLevel.filter(
          (item) => item.habits.length > 0
        );
        if (
          Array.isArray(notificationSentArrayLevelFinal) &&
          notificationSentArrayLevelFinal.length > 0
        ) {
            this.counterId = 0;
          this.appState.set("counterId", 0);
          this.appState.set('repeatLevelCount',0)
          this.showDialog(
            notificationSentArrayLevelFinal,
            this.appState.get("counterId"),
            this.appState.get('repeatLevelCount')
          );
        }
      },
      (error) => {
        this.toasterService.error(this.i18n.t(
          "Server or connection issue. Please check your internet connection."
        ));
        console.log("error :", error);
      }
    );
  }

  async showDialog(notificationSentArrayLevelFinal: any[], routineLevel, levelCountIndex?) {
    try {
      if (routineLevel >= notificationSentArrayLevelFinal.length) return; //finished processing
      let currentNotifyRoutieLevels = notificationSentArrayLevelFinal[routineLevel]?.habits?.length;
      var lastLevel =
        notificationSentArrayLevelFinal[
          notificationSentArrayLevelFinal.length - 1
        ].habits[ notificationSentArrayLevelFinal[
          notificationSentArrayLevelFinal.length - 1
        ].habits?.length-1];
      var firstLevel = notificationSentArrayLevelFinal[routineLevel].habits[levelCountIndex];

      const isAfterDay = moment().isAfter(firstLevel.endDate);
      if (lastLevel?.id === firstLevel?.id) {
        this.appState.set("isNotificationViewed", true);
      }
      else {
        this.appState.set("isNotificationViewed", false);
      }
      if (isAfterDay) {
        const dialogRef = this.dialog.open(AlertNotificationUpdateComponent, {
          data: {
            dataKey: { routine: firstLevel },
          },
        });
        dialogRef.afterClosed().subscribe((result) => {
          //I need to enable this block before i push code for 2153
          this.turnOffNotifications(
            notificationSentArrayLevelFinal[routineLevel],
            firstLevel,
            notificationSentArrayLevelFinal,
            routineLevel
          ).subscribe(
            (response) => {
          if (levelCountIndex+1 == currentNotifyRoutieLevels) {
            this.appState.set("counterId", routineLevel + 1);
            this.appState.set('repeatLevelCount',0)
          }
          else {
            this.appState.set('repeatLevelCount', levelCountIndex + 1)
            this.appState.set("counterId", routineLevel)
          }
          
              if (result == undefined) {
                this.showDialog(notificationSentArrayLevelFinal, levelCountIndex+1 == currentNotifyRoutieLevels?routineLevel+1:routineLevel, levelCountIndex+1 == currentNotifyRoutieLevels?0: levelCountIndex+1); //Recursively open next dialog
              }
              if (result === "confirm") {
                const dialogRef = this.dialog.open(AlertReviewRoutineComponent, {
                  data: {
                    dataKey: { routine: firstLevel },
                  },
                });
                dialogRef.afterClosed().subscribe((result) => {
                  if (result == undefined) {
                    this.showDialog(notificationSentArrayLevelFinal, levelCountIndex+1 == currentNotifyRoutieLevels?routineLevel+1:routineLevel, levelCountIndex+1 == currentNotifyRoutieLevels?0: levelCountIndex+1); //Recursively open next dialog
                  }
                  //this.appState.set('isNotificationViewed',true)
                  var routineAnswer = firstLevel.commitmentStatement;
                  if (result === "confirm") {
                    //yes
                    if (firstLevel) {
                      if (firstLevel.isSingleEvent === null) {
                        //return;
                        this.commitService.earlierOptedNotsureTimesDays(routineAnswer,
                          notificationSentArrayLevelFinal[routineLevel],
                          firstLevel, firstLevel?.isSingleEvent)
                      }
                      this.commitService.sameCueOptSelection(firstLevel?.isSingleEvent,
                        routineAnswer,
                        notificationSentArrayLevelFinal[routineLevel], firstLevel, true)
                      // if (firstLevel.isSingleEvent) {
                      //   this.openRoutineCalendar(
                      //     false,
                      //     routineAnswer,
                      //     firstLevel,
                      //     notificationSentArrayLevelFinal,
                      //     notificationSentArrayLevelFinal[routineLevel],
                      //     routineLevel
                      //   ); //false
                      // } else {
                      //   this.openRoutineCalendar(
                      //     true,
                      //     routineAnswer,
                      //     firstLevel,
                      //     notificationSentArrayLevelFinal,
                      //     notificationSentArrayLevelFinal[routineLevel],
                      //     routineLevel
                      //   ); //TODO ;  true
                      // }
                      this.appState.set("isConfirmed", true);
                    }
                  } else if (result === "change") {
                    //No, change cue
                    this.appState.set("changeCue", true);
                    this.appState.set('levelEdit', true)
                    this.appState.set("isRoutineEdited", true);
                    this.onSubmit(notificationSentArrayLevelFinal[routineLevel], firstLevel, true)

                  } else if (result === "turnOff") {
                    //No, turn off reminders
                    // this.turnOffNotifications(
                    //   notificationSentArrayLevelFinal[routineLevel],
                    //   firstLevel,
                    //   notificationSentArrayLevelFinal,
                    //   routineLevel
                    // );
                    const dialogRef = this.dialog.open(AlertConfirmNotificationComponent, {
                      data: {
                        dataKey: { level: firstLevel },
                      },
                    });
                    dialogRef.afterClosed().subscribe((result) => {
                      notificationSentArrayLevelFinal[routineLevel].routine = notificationSentArrayLevelFinal[routineLevel]?.originalRoutine;
                      let unCommittedLevel = this.getRoutineLockedLevel(notificationSentArrayLevelFinal[routineLevel])
                      if (unCommittedLevel) {
                        this.levelSwitchCodeCheck(notificationSentArrayLevelFinal[routineLevel], firstLevel)
                      }
                      else {
                        this.showDialog(notificationSentArrayLevelFinal, levelCountIndex+1 == currentNotifyRoutieLevels?routineLevel+1:routineLevel, levelCountIndex+1 == currentNotifyRoutieLevels?0: levelCountIndex+1); //Recursively open next dialog //Recursively open next dialog
                      }
                    });
                  }
                });
              }
            });
        });
      }
      else {
        //Need to uncomment before push 2153
        this.turnOffNotifications(
          notificationSentArrayLevelFinal[routineLevel],
          firstLevel,
          notificationSentArrayLevelFinal,
          routineLevel
        ).subscribe(
          (response) => {
          if (levelCountIndex+1 == currentNotifyRoutieLevels) {
            this.appState.set("counterId", routineLevel + 1);
            this.appState.set('repeatLevelCount',0)
          }
          else {
            this.appState.set('repeatLevelCount', levelCountIndex + 1)
            this.appState.set("counterId", routineLevel)
          }
             this.showDialog(notificationSentArrayLevelFinal, levelCountIndex+1 == currentNotifyRoutieLevels?routineLevel+1:routineLevel, levelCountIndex+1 == currentNotifyRoutieLevels?0: levelCountIndex+1); //Recursively open next dialog
       });
      }
    } catch (error) {
      this.toasterService.error(this.i18n.t(
        "Server or connection issue. Please check your internet connection."
      ));
      console.log("Error for routines ", error);
    }
  }

    async editCommitmenntConfirmation(isSingleEvent,subRoutineAnswer,level,notificationSentArrayLevelFinal,routine,routineLevel) {
  //    console.log("result after modal close");
  //     var routineTime = this.appState.get('routineTime')
  //     var routineDay = this.appState.get('selectedDate')
  //     if (!routineTime) { routineTime = '' }
  //     if (!routineDay) { routineDay = '' }

  //     // if (routineDay) {
  //     //   var today = (routineDay).getDay();
  //     //   var dayName = this.routinev2Service.getDayFromDate(today)
  //     // }
  //     if (!this.activityCueTime) { this.activityCueTime = '' }
  //     if (this.commitType === 'Activity' && !this.activityCueTime) { this.activityCueTime = 'before' }
  //     var differentTimes = this.appState.get('differentTimes')
  //     var differentDays = this.appState.get('differentDays')
  //     if (differentTimes) {
  //       differentTimes = this.routineService.formatTimeForFrontEnd(differentTimes);
  //     }
  //     if (differentDays && differentDays?.length>0) {
  //       this.dayTimeArray = differentDays.map(function (x, i) {
  //         return x + " " +this.i18n.t("at")+ " "  + differentTimes[i]
  //       })

  //       this.subRoutineAnswer = this.routineService.createCommitEvent(routine, level, this.typeValue,
  //         this.activityCueTime,
  //         differentTimes, differentDays, this.commitType, this.makeCommitment, this.i18n.t("on") + " " + this.dayTimeArray.join(', '))
  //     } else if (!differentDays || differentDays?.length==0) {
  //       differentDays = 'every day'
  //       this.dayTimeArray = differentDays + " at " + differentTimes
  //       this.subRoutineAnswer = this.routineService.createCommitEvent(routine, level, this.typeValue, this.activityCueTime, differentTimes, differentDays, this.commitType, this.makeCommitment, this.dayTimeArray)
  //     }

  //     if (differentTimes?.length >= 1) {
  //       const alert = await this.alertController.create({      
  //         header: this.i18n.t("My Commitment"),
  //         message: this.subRoutineAnswer,
  //         cssClass: 'alertBackdrop',
  //         buttons: [
  //           {
  //             cssClass:"alert-edit",
  //             text: this.i18n.t("Edit"),
  //             handler: async () => {
  //               this.appState.set('dayTimeArray', this.dayTimeArray)
  //               this.appState.set('isTimeEdited', true)
  //                 if (this.appState.get("routineCalendarData")?.isSingleEvent) {
  //                    isSingleEvent= !this.appState.get("routineCalendarData")?.isSingleEvent
  //                  }
  //                   this.openRoutineCalendar(isSingleEvent?false:true,
  //                     subRoutineAnswer,
  //                     level,
  //                     notificationSentArrayLevelFinal,
  //                     routine,
  //                     routineLevel)
  //             },
  //             role: 'cancel',
  //           },
  //           {
  //             text: this.i18n.t("Commit"),
  //             cssClass: 'alert-commite-btn alert-commite-btn',
  //             handler:(result)=>{
  //               this.commitService.makeRoutine(routine, level)
  //             },
             
  //         },
            
  //       ]
  //     });
      
  //     await alert.present();
  //     alert.onWillDismiss().then(async (result) => {
  //       if (result?.role === 'backdrop') {
  //         if (this.appState.get('IsRepsAppendAfterReoptCommit') == true) {
  //           this.closingModalOnClickingBackground();
  //         }
  //       }
  //     })
  //     }
  //     else {
  //       if (this.appState.get('IsRepsAppendAfterReoptCommit') == true) {
  //           this.closingModalOnClickingBackground();
  //         }
  //     }
   }

  openRoutineCalendar(
    isSingleEvent: boolean,
    subRoutineAnswer: any,
    level: any,
    notificationSentArrayLevelFinal: any,
    routine,
    routineLevel: any
  ) {
    var data = {
      text: level.text,
      title: level.title,
      routineAnswer: subRoutineAnswer,
      level: level,
      isSingleEvent: isSingleEvent,
      routineTime: level?.habitCommitment?.habitTime,
      selectedDays: level?.habitCommitment?.habitDifferentDateTime && level?.habitCommitment?.habitDifferentDateTime?.length>0?level?.habitCommitment?.habitDifferentDateTime?.map(d =>
        new Date(d).toLocaleDateString('en-US', { weekday: 'long' })): [],
    };

    this.appState.set("routineCalendarData", data);
    this.appState.set("isRoutineCalender", true);

    var differentTimes = level?.habitCommitment?.habitTime;
    var differentDays = level?.habitCommitment?.habitDifferentDateTime && level?.habitCommitment?.habitDifferentDateTime?.length>0?level?.habitCommitment?.habitDifferentDateTime?.map(d =>
        new Date(d).toLocaleDateString('en-US', { weekday: 'long' })): [];

    const dialogRef = this.dialog.open(WeekendCalendarComponent, {
      panelClass: "weekendCommitment",
      maxHeight: "88%",
      // height: "80%",
      width: "100%",
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.appState.set("isRoutineCalender", false);
      this.editCommitmenntConfirmation(isSingleEvent,subRoutineAnswer,level,notificationSentArrayLevelFinal,routine,routineLevel)
      });
  }
  turnOffNotifications(
    routine: any,
    level: any,
    notificationSentArrayLevelFinal: any,
    routineLevel: any
  ) {
    this.currentUser = this.appState.get('currentUser');
    this.path = this.appState.get('currentPath');
    const requestData = {
      // user_id: this.currentUser.id,
      // path_id: routine?.pathId,
      notification_sent: false,
      habit_id: level.id,
      habit_group_id: routine.habitGroupId,
    };
    return this.homev5Service.disableNotification(requestData)
  }

  async openDailyStepsComponent(comp?, compProps?,className?){
 
    if(comp) {
      const modal = await this.modalController.create({
        component: comp,
        componentProps: compProps,
        //animated: false,
        cssClass: className?className:'custom-modal',
         enterAnimation: this.animationService.slideInUpEnterAnimation,
         leaveAnimation: this.animationService.slideOutDownLeaveAnimation
      });
      await modal.present() 
      modal.onWillDismiss().then((data) => {
        this.currentUser = this.appState.get('currentUser')
        this.path = this.appState.get('currentPath')
        if (this.appState.get('IsRepsAppendAfterReoptCommit') == true) {
         this.closingModalOnClickingBackground();
        }
        if (this.appState.get('isLevelClosedBeforeCommit') == true) {
          this.closingModalOnClickingBackgroundForUnLockedCommit();
        }
         if (data?.data?.nextHabitUnlockFromToDoScreen == 'nextHabitUnlockFromToDoScreen') {
           setTimeout(() => {
             this.openDailyStepsComponent(DailyStepsContentWebModalV2Component, { currentDay: data?.data?.currentDay, startFromScreen: 'daily-content-screen-todo' }, 'web-daily-steps-custom-modal');
           }, 600);
         }
         if(data?.data?.isInstepTodoScreen) {
          this.unlockNextHabitLevel();
         }
        if (!this.appState.get("isNotificationViewed")) {
          this.getAllRoutines(this.path.id)
        }
        if (data?.data?.isAlertUnlockClosed) {
          this.appState.set("reviewingStepIndex", JSON.parse(localStorage.getItem('unlockingHabitStepDetails'))?.stepIndex);
          let chapterPosition= JSON.parse(localStorage.getItem('unlockingHabitStepDetails'))?.chapterIndex
          this.appState.set('isLevelClosedBeforeCommit', true)
          localStorage.removeItem('unlockingHabitStepDetails')
            this.openDailyStepsComponent(DailyStepsContentWebModalV2Component,{currentDay: data?.data?.currentDay,startFromScreen: 'daily-content-screen-routine-sub-level',currentOpenedChapter:chapterPosition},'web-daily-steps-custom-modal')
         }
      })
    }
   
  }
  
  unlockNextHabitLevel() {
    let dailyStepsArray= this.appState.get("DailyStepsData");
    let levelUpdateData = this.appState.get("levelUpdateData");
    let currentDay = this.appState.get('currentScheduleDay')

    let allLevelsCompleted = this.appState.get("allLevelsCompleted");
    // if (levelUpdateData?.levelUpdated === true) {
    //   this.appState.set("LevelNumber", levelUpdateData?.level.level + 1);
    //   const last =
    //     levelUpdateData?.routine.routine[
    //       levelUpdateData?.routine.routine.length - 1
    //     ];
    //   var isLastRepLogged = levelUpdateData?.level.reps_commit.filter(
    //     (item) => item.is_completed === true
    //   );

    //   if (
    //     levelUpdateData &&
    //     levelUpdateData.level.reps_commit.length ==
    //       isLastRepLogged.length + 1 &&
    //     last.id === levelUpdateData.level.id
    //   ) {
    //     if (allLevelsCompleted === true) {
    //       console.log("do nothing :");
    //     } else {
           this.appState.set("levelUpdateData", undefined);
          setTimeout(()=>{
            this.openAlertGiveFeedbackCommitmentComponent(levelUpdateData.routine,levelUpdateData?.level);
          },600)
    //     }
    //   } else {
    //     this.appState.set("levelUpdated", true);
    //     setTimeout(()=>{
    //       this.openDailyStepsComponent(AlertUnlockLevelComponent,{nextLevelData:levelUpdateData.routine.schedule_day},'web-alert-unlock-custom-modal')
    //     },600);
        
        
    //   }
    // }

    let levelSaveData = this.appState.get("levelSaveData");
    if (levelSaveData && dailyStepsArray[currentDay]?.stepStatus=='Review') {
      localStorage.setItem(
        `Toggle:Day:${levelSaveData.currentDay}:LevelNumber:${levelSaveData.levelId}:true`,
        "true"
      );
      this.appState.set("showUpdatedScreens", undefined);
      this.appState.set("levelSaveData", undefined);
    }
   }

  closeAllModals(currentDay, currentStepInfo, screenId?) {
    // close background modals and opens daily steps modal for web
    this.modalController.dismiss()
    setTimeout(() => {
      this.modalController.dismiss()
    }, 550);

    setTimeout(() => {
      this.openNextComponent(
        DailyStepsContentWebModalV2Component,
        { currentDay: currentDay, currentOpenedChapter: currentStepInfo?.chapterIndex,currentOpenedStep:currentStepInfo?.stepIndex, startFromScreen: screenId ? screenId : null },
        'web-daily-steps-custom-modal')
    }, 1100);
  }
  checkSubpathStatus() {
    let currentScreenId = 'no-onboarding-screen';
    this.currentUser = this.appState.get("currentUser");
    this.path = this.appState.get("currentPath");
    this.currentClient = this.appState.get("currentClient");
    const request = {
      user_id: this.currentUser.id,
      active_path_id: this.currentUser.activePathId,
      isonboardingcompleted: true,
    };

    this.homev5Service.onbordingCompleted(request).subscribe(
      (response) => {
        this.analyticsService.setOnboardingEvent('Onboarding', 'Onboarding completed', currentScreenId, this.path?.id, this.currentClient?.id)
      },
      (error) => {
        console.log("Response of subpath status ", error);
      }
    );
  }

  getStepwiseActionPoint(data): Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    const params = new HttpParams().append('user_id', data.user_id)
                                   .append('path_id', data.path_id)
                                   .append('scheduled_day', data.currentDay);
    return this.httpclient.get(this.API_URL + this.GET_STEP_ACTION_POINTS_DATA, { headers, params }).pipe(
      map(response => {
        return response
      })
    )
  }

   getKyperStepwiseActionPoint(data): Observable<any> {
    const headers = new HttpHeaders();
    headers.set('Authorization', localStorage.getItem('token'));
    const params = new HttpParams().append('step_id', data)
    return this.httpclient.get(this.API_URL + this.get_keyper_earned_action_points, { headers, params }).pipe(
      map(response => {
        return response
      })
    )
  }

  // Urls that 404'd once. Deleting a photo leaves the old S3 link on any user
  // object cached before the delete, and it never resolves again.
  private failedProfilePhotoUrls = new Set<string>()

  // The User model is camelCase but feed, comment and leaderboard payloads come
  // straight off the API in snake_case, so accept either shape.
  getProfilePhotoUrl(userDetails): string {
    return userDetails?.imageUrl || userDetails?.image_url || ''
  }

  // A deleted photo is saved as "nil" and a user who never uploaded one carries
  // the shared avatar.png — neither is renderable, so both fall back to initials.
  hasProfilePhoto(userDetails): boolean {
    const imageUrl = this.getProfilePhotoUrl(userDetails)
    return !!imageUrl
      && imageUrl !== 'nil'
      && !imageUrl.includes('required_images/avatar.png')
      && !this.failedProfilePhotoUrls.has(imageUrl)
  }

  // Bound to the <img> (error) event: once a url is known bad, hasProfilePhoto()
  // turns false and every screen showing that user swaps to initials instead of
  // leaving a broken image behind.
  onProfilePhotoError(userDetails): void {
    const imageUrl = this.getProfilePhotoUrl(userDetails)
    if (imageUrl) {
      this.failedProfilePhotoUrls.add(imageUrl)
    }
  }

  liveProfileUser(author, alternate = null) {
    const currentUser = this.appState.get('currentUser')
    if (author?.id && author.id === currentUser?.id) {
      return currentUser
    }
    if (alternate && alternate.id === author?.id
      && !this.hasProfilePhoto(author)
      && this.hasProfilePhoto(alternate)) {
      return alternate
    }
    return author
  }

  getThumbnailInitials(userDetails) {
     let userInitials;
    if (userDetails?.first_name || userDetails?.last_name) {
        userInitials = userDetails?.first_name.charAt(0).toUpperCase() + userDetails?.last_name?.charAt(0).toUpperCase()
    }
    else  if (userDetails?.firstName || userDetails?.lastName) {
        userInitials = userDetails?.firstName.charAt(0).toUpperCase() + userDetails?.lastName?.charAt(0).toUpperCase()
    }
    //leaderboard
    else if (userDetails?.name) {
      const names = userDetails?.name?.split(" ");
      if (names?.length > 1) {
        userInitials = names[0].charAt(0).toUpperCase()+names[names?.length-1].charAt(0).toUpperCase()
      }
      else {
        userInitials = names[0].charAt(0).toUpperCase();
      }
    }
    return userInitials
  }
  
  getContrastColor(hexColor: string): string {
    if (hexColor?.length === 4 && hexColor.startsWith("#")) {
      hexColor= `#${hexColor[1]}${hexColor[1]}${hexColor[2]}${hexColor[2]}${hexColor[3]}${hexColor[3]}`;
    }
    const hex = hexColor?.replace("#", "");
    let luminance;
    if (hex) {
      const r = parseInt(hex.substring(0, 2), 16);
      const g = parseInt(hex.substring(2, 4), 16);
      const b = parseInt(hex.substring(4, 6), 16);

      // Calculate luminance
       luminance = 0.299 * r + 0.587 * g + 0.114 * b;
    }
   
    // Return black for bright colors, white for dark colors
    return luminance > 186 ? "black" : "white";
  }
  rgbToHex(color: string): string {
  // Extract RGB or RGBA values from the input string
  const rgbaMatch = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)$/);

  if (!rgbaMatch) {
    throw new Error('Invalid color format');
  }

  const r = parseInt(rgbaMatch[1], 10);
  const g = parseInt(rgbaMatch[2], 10);
  const b = parseInt(rgbaMatch[3], 10);
  const a = rgbaMatch[4] !== undefined ? parseFloat(rgbaMatch[4]) : 1;

  // Convert RGB to hexadecimal
  const hexR = r.toString(16).padStart(2, '0');
  const hexG = g.toString(16).padStart(2, '0');
  const hexB = b.toString(16).padStart(2, '0');

  // If alpha is provided and is less than 1, convert it to hex as well
  const hexA = a < 1 ? Math.round(a * 255).toString(16).padStart(2, '0') : '';

  return `#${hexR}${hexG}${hexB}${hexA}`;
}
  appendRepsOnreoptLevel(routine, level) {
     this.currentUser = this.appState.get("currentUser");
    if (this.appState.get('IsRepsAppendAfterReoptCommit') ==true) {
      let someArray = []
      let level_ids = [];
      routine.screen?.content?.habits?.forEach(element => {
        if (element.id == level.id) {
          someArray.push(element)
          level_ids.push(element.id)
        }
      });
      const repsRequestData = {
        // user_id: this.currentUser?.id,
        // is_reset: true,
        // level_id: JSON.stringify(level_ids),
        // routine_info_id: routine.id,
        // path_id:routine?.path_i
        habit_group_id: routine?.screenContentId,
        habit_id:level?.id
      }
   
      if (!repsRequestData.habit_group_id) {
        return true;
      } else {
        this.routineService.appendRepsCount(repsRequestData).subscribe((res) => {
          console.log("response for reps", res);
              this.appState.set('IsRepsAppendAfterReoptCommit',null)
        })
        //   this.routineService.appendOptedRoutineLevels(repsRequestData).subscribe(
        // (response) => {
        //   this.appState.set('levelUpdated', undefined)
        //  // this.cdRef.detectChanges();
        // },
        // (error) => {
        //   console.log('Error for edit routines', error)
        // })
      }
    }  
  }
  async closingModalOnClickingBackgroundForUnLockedCommit() {
    if (this.appState.get('isLevelClosedBeforeCommit') == true) {
      this.appState.set('isLevelClosedBeforeCommit', null)
      this.appState.set('levelUpdated', undefined)
      this.appState.set('showUpdatedScreens', undefined)
      this.appState.set('isTodoReps', undefined)
      this.appState.set('lastTodoScreenStep', undefined)
      this.appState.set('fromTodoWidget', undefined)
      this.appState.set('levelEdit', undefined)
       setTimeout(() => {
        let openedRoutineInfo = this.appState.get('routinneLevelInfo')
        if (openedRoutineInfo?.routine && openedRoutineInfo?.habits) {
           this.resetLevelEnabledStatus(openedRoutineInfo?.routine, openedRoutineInfo?.habits)
        }
        this.appState.set('routinneLevelInfo', undefined)
      }, 650);
      let alert = await this.alertController.create({
        cssClass:'habit-alert-not-committed',
        header:this.i18n.t('Commitment not confirmed'),
        subHeader: this.i18n.t('You can find and commit to this Habit in the Not Committed section of your To-Do List.'),
        buttons: [
          {
            cssClass:"alert-ok-btn",
            text: this.i18n.t('OK'),
            role: 'confirm',
            handler: () => {
              
            }
          }
        ]

      })
      await alert.present();
    }
  }
  async closingModalOnClickingBackground() {
    if (this.appState.get('IsRepsAppendAfterReoptCommit') == true) {
      this.appState.set('IsRepsAppendAfterReoptCommit', null)
      this.appState.set('levelUpdated', undefined)
      this.appState.set('showUpdatedScreens', undefined)
       this.appState.set('isTodoReps', undefined)
      this.appState.set('lastTodoScreenStep', undefined)
      this.appState.set('fromTodoWidget', undefined)
      this.appState.set('levelEdit', undefined)
        setTimeout(() => {
        let openedRoutineInfo = this.appState.get('routinneLevelInfo')
        if (openedRoutineInfo?.routine && openedRoutineInfo?.habits) {
           this.resetLevelEnabledStatus(openedRoutineInfo?.routine, openedRoutineInfo?.habits)
        }
        this.appState.set('routinneLevelInfo', undefined)
      }, 650);
      let alert = await this.alertController.create({
         cssClass:'habit-alert-not-committed',
       header:this.i18n.t('Commitment not confirmed'),
        subHeader: this.i18n.t('You can find and re-commit to this Habit in the Completed section of your To-Do List.'),
        buttons: [
          {
            cssClass:"alert-ok-btn",
            text: this.i18n.t('Ok'),
            role: 'confirm',
            handler: () => {
              
            }
          }
        ]

      })
      await alert.present();
    }
  }
  unlockedLevelsList(routines) {
    let count=0;
    routines?.forEach((subRoutine) => {
      subRoutine?.habits?.forEach((level) => {
        if ((level?.isHabitUnlocked == true || level?.isUnlocked == true) && level?.isHabitCompleted == false) {
          count = count + 1;
        }
      })
    })
    return count;
  }
  getMimeType(fileName: string): string {
  const ext = fileName.split('.').pop()?.toLowerCase();
  switch (ext) {
    case 'pdf': return 'application/pdf';
    case 'ppt':
    case 'pptx': return 'application/vnd.ms-powerpoint';
    case 'doc':
    case 'docx': return 'application/msword';
    case 'jpg':
    case 'jpeg': return 'image/jpeg';
    case 'png': return 'image/png';
    default: return 'application/octet-stream';
  }
}
}
